@if (invoiceSignal(); as invoice) {
<ion-label>
  <h3>
    <div class="flex flex-row justify-between">
      <div>
        {{ studentSignal()?.forename }}
        {{ studentSignal()?.surname }}
      </div>
      <div>CHF {{ invoice.total_amount | number: "1.2-2" }}</div>
    </div>
  </h3>
  <div>
    <div class="flex flex-row justify-between items-center mt-2">
      <p class="text-gray-500">
        Rechnung vom {{ invoice.created_at | date : "dd.MM.yyyy" }}
      </p>
      <ion-badge
        [color]="
          (invoice.paid_amount ?? 0) === invoice.total_amount
            ? 'success'
            : convertToDate(invoice.due_date) > today
            ? 'primary'
            : 'danger'
        "
        mode="ios"
        >{{
          invoice.paid_amount === invoice.total_amount ||
          invoice.total_amount === 0
            ? "Bezahlt"
            : invoice.paid_amount && invoice.paid_amount !== 0
            ? "Teilzahlung"
            : convertToDate(invoice.due_date) > today
            ? "Fällig"
            : "Überfällig"
        }}</ion-badge
      >
    </div>
  </div>
</ion-label>
}
